<template>
    <div class="row">
        <div class="col-8">
            <portlet
                    :icon="'fi flaticon-group'"
                    :title="'Controleurs'"
            >
                <div slot="portletBody">
                    <div class="input-group mb-5">
                        <input type="text" class="form-control" v-model="newTesterName"
                               placeholder="Controleur toevoegen">
                        <button @click="cTester" :disabled="!newTesterName.length" class="btn btn-primary">
                            Toevoegen
                        </button>
                    </div>

                    <input type="text" class="form-control mb-4" v-model="search" placeholder="Controleur zoeken...">

                    <draggable v-show="!search" v-model="testersList" class="dragArea">
                        <div v-for="(tester, index) in filteredTestersList" :key="index" :class="'item-row '+ tester.id"  data-toggle="tooltip" data-placement="top" title="Versleep de controleurs omhoog of omlaag voor een andere volgorde">
                            <i class="drag-drop-icon far fa-ellipsis-v"></i>
                            <span class="tester-name">{{tester.name}}</span>
                            <span class="item-actions">
                                <a href="javascript:;" @click="selectedTester = tester">
                                    <i class="fas fa-pencil tester-edit-icon"></i>
                                </a>
                                <a href="javascript:;" @click="deleteTester(tester.id)">
                                    <i class="fas fa-trash tester-remove"></i>

                                </a>
                            </span>
                        </div>
                    </draggable>


                    <div v-show="search" v-model="testersList">
                        <div v-for="(tester, index) in filteredTestersList" :key="index" :class="'item-row '+ tester.id">
                            <i class="drag-drop-icon far fa-ellipsis-v"></i>
                            <span class="tester-name">{{tester.name}}</span>
                            <span class="item-actions">
                                <a href="javascript:;" @click="selectedTester = tester">
                                    <i class="fas fa-pencil tester-edit-icon"></i>
                                </a>
                                <a href="javascript:;" @click="deleteTester(tester.id)">
                                    <i class="fas fa-trash tester-remove"></i>
                                </a>
                            </span>
                        </div>
                        <div class="item-row" v-if="filteredTestersList.length < 1">
                            <span v-show="search">
                                Er zijn geen zoekresultaten met: {{search}}
                            </span>
                        </div>
                    </div>


                </div>
            </portlet>
        </div>
        <div class="col-4">
            <portlet
                    :icon="'fi flaticon-pencil'"
                    :title="'Controleur aanpassen'"
            >
                <div slot="portletBody" class="edit-tester-form">
                    <div v-if="selectedTester">
                        <input type="text" v-model="selectedTester.name" class="form-control tester-edit mb-4">
                        <button @click="editTester" class="btn btn-primary btn-block">Opslaan</button>
                    </div>
                    <p v-else>Selecteer controleur om aan te passen</p>
                </div>
            </portlet>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import draggable from 'vuedraggable'

    export default {
        components: {
            draggable
        },
        data() {
            return {

                search: '',

                newTesterName: '',
                selectedTester: ''
            }
        },
        computed: {
            ...mapGetters('testers', [
                'getTesters'
            ]),
            testersList: {
                get() {
                    return this.$store.state.testers.testers;
                },
                set(value) {
                    this.$store.commit('testers/setTesters', value)
                }

            },
            filteredTestersList() {
                var self = this

                return this.getTesters.filter(function (testers) {
                    return testers.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                });

            }
        },
        methods: {
            ...mapActions('testers', [
                'getTestersFromApi',
                'createTester',
                'saveTester',
                'postTesterOrder',
                'deleteTester'
            ]),
            cTester() {
                if (this.newTesterName) {
                    this.createTester({
                        name: this.newTesterName,
                    }).then((this.newTesterName = ""))
                }
            },
            editTester() {
                if($('.tester-edit').val() !== '') {
                    this.saveTester(this.selectedTester);
                    this.selectedTester = null;
                }
            },
        },
        watch: {
            testersList() {
                this.postTesterOrder()
            }
        },
        updated(){
            $('[data-toggle="tooltip"]').tooltip()
        },
        created() {
            this.getTestersFromApi()
        }
    }
</script>